<template>
  <div
    class="nv-dialog-popup"
    :style="{
      transform: visible ? 'translateX(0)' : 'translateX(-100vw)'
    }"
  >
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // display: none/block could lead error to display ads
    // so did visibility: hidden/visible
    // because the ads must be in viewport and adsense will check parent's visibility
    // but we still want to pre-load the ad first
    // the transform would be the best choice
    visible: Boolean
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.nv-dialog-popup {
  height: 100vh !important;
  width: 100vw !important;
  position: fixed;
  top: 0;
  width: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
